import { useEffect } from 'react'

// Hotjar ID configurado - altere aqui para ativar/desativar
// Para desativar: coloque "" (string vazia) ou null
// Para ativar: coloque o número do seu Hotjar ID (ex: "6600314")
const HOTJAR_ID = '6600314'

const HotjarScript = () => {
  useEffect(() => {
    // Só carrega em produção e se HOTJAR_ID estiver configurado
    const isProduction = import.meta.env.PROD

    if (!isProduction || !HOTJAR_ID) {
      if (!isProduction) {
        console.log('[Hotjar] Não carregado - ambiente de desenvolvimento')
      }
      return
    }

    // Verifica se já foi carregado para evitar duplicação
    if ((window as any).hj) {
      return
    }

    // Inicializa o objeto Hotjar
    ;(window as any).hj =
      (window as any).hj ||
      function () {
        ;((window as any).hj.q = (window as any).hj.q || []).push(arguments)
      }
    ;(window as any)._hjSettings = { hjid: parseInt(HOTJAR_ID), hjsv: 6 }

    // Carrega o script de forma assíncrona
    const script = document.createElement('script')
    script.src = `https://static.hotjar.com/c/hotjar-${HOTJAR_ID}.js?sv=6`
    script.async = true
    script.defer = true
    script.id = 'hotjar-script'

    document.head.appendChild(script)

    return () => {
      // Cleanup: remove o script se o componente for desmontado
      const existingScript = document.getElementById('hotjar-script')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return null
}

export default HotjarScript
